import i18n from '@app/localization/i18n';
import { logger } from '@app/logger';
import { addFederationRoutes } from '@app/router';

export async function initializeShops(): Promise<void> {
    try {
        const shopsModule = await import('shops/initializeShops');
        return shopsModule.initializeShops({ addRoutes: addFederationRoutes, locale: i18n.locale });
    } catch (error) {
        logger.error(error as Error);
    }
}
